import {create} from 'zustand';

type SplashCover = 'covering' | 'revealing' | 'none';

type SplashCoverStore = {
  cover: SplashCover;
  setCover: (cover: SplashCover) => void;
};

export const useSplashCoverStore = create<SplashCoverStore>(set => ({
  cover: 'none',
  setCover: cover => set({cover}),
}));
